module.exports = "<form name=\"form\">\n  <div class=\"card-panel short-padding\">\n    <my-train-form my-train=\"myTrain\"\n      enable-validator=\"true\"\n      enable-required=\"true\"\n      enable-arrival=\"true\"\n      my-id=\"train\">\n    </my-train-form>\n  </div>\n\n  <my-cancel-validate-buttons my-label=\"$root.labels.edit\"\n    my-icon=\"$root.icons.edit\"\n    my-click=\"updateTrain(myTrain)\"\n    my-disabled=\"form.$invalid\">\n  </my-cancel-validate-buttons>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/trains/train/directives/forms/myTrainEditForm.html
// module id = 1072
// module chunks = 0